import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface CardContentProps {
    className?: string;
    children: ReactNode;
}

const CardContent = ({ className, children }: CardContentProps) => {
    return <div className={clsx('p-4 pt-5', className)}>{children}</div>;
};

export default CardContent;
